<template>
  <div class="dp-page">

    <!-- Hero -->
    <div class="dp-hero">
      <div class="d-flex align-center" style="gap:14px;">
        <v-avatar color="rgba(255,255,255,0.15)" size="46">
          <v-icon color="white" size="26">mdi-bank-transfer-in</v-icon>
        </v-avatar>
        <div>
          <div class="dp-hero__title">Depósitos a Caja desde Otra Sede</div>
          <div class="dp-hero__sub">Registro y verificación de transferencias entre sedes</div>
        </div>
      </div>
      <v-chip small color="rgba(255,255,255,0.15)" dark class="dp-hero__chip">
        <v-icon left small>mdi-bank-outline</v-icon> Contabilidad
      </v-chip>
    </div>

    <div class="dp-body">

      <!-- Barra -->
      <v-card outlined class="dp-toolbar-card mb-4">
        <v-card-text class="py-2 px-4">
          <div class="d-flex align-center justify-space-between flex-wrap" style="gap:8px;">
            <div class="d-flex align-center" style="gap:8px;">
              <v-btn small outlined color="blue darken-2" @click="cargarDatos()" :loading="loading">
                <v-icon left small>mdi-refresh</v-icon> Actualizar
              </v-btn>
              <v-chip x-small :color="desserts.length ? 'blue lighten-5' : 'grey lighten-3'"
                class="blue--text text--darken-2 font-weight-medium">
                {{ desserts.length }} registro{{ desserts.length !== 1 ? 's' : '' }}
              </v-chip>
            </div>
          </div>
        </v-card-text>
      </v-card>

      <!-- Tabla -->
      <v-card outlined class="dp-table-card">
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="desserts"
          :items-per-page="10"
          loading-text="Cargando depósitos..."
          no-data-text="No hay depósitos registrados"
          class="dp-table"
        >
          <!-- Estado -->
          <template v-slot:[`item.estado`]="{ item }">
            <v-chip x-small label :color="estadoColor(item.estado).bg" :class="estadoColor(item.estado).text">
              <v-icon left x-small>{{ estadoColor(item.estado).icon }}</v-icon>
              {{ getEstado(item.estado) }}
            </v-chip>
          </template>

          <!-- Montos -->
          <template v-slot:[`item.monto_depositado`]="{ item }">
            <span class="font-weight-medium teal--text text--darken-1">{{ item.monto_depositado }} Bs</span>
          </template>
          <template v-slot:[`item.monto_recaudado`]="{ item }">
            <span class="font-weight-medium blue--text text--darken-1">{{ item.monto_recaudado }} Bs</span>
          </template>

          <!-- Sedes -->
          <template v-slot:[`item.sede_caja`]="{ item }">
            <span class="text-body-2">{{ item.sede_caja ? item.sede_caja.nombre : '—' }}</span>
          </template>
          <template v-slot:[`item.sede`]="{ item }">
            <span class="text-body-2">{{ item.sede ? item.sede.nombre : '—' }}</span>
          </template>

          <!-- Acciones -->
          <template v-slot:[`item.opt`]="{ item }">
            <div class="d-flex align-center" style="gap:2px;">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon small color="blue darken-1" @click="obtenerDetalles(item.id)">
                    <v-icon small>mdi-eye-outline</v-icon>
                  </v-btn>
                </template>
                <span>Ver detalles</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon small color="green darken-1"
                    :disabled="item.estado == 3" @click="verificaropen(item)">
                    <v-icon small>mdi-check-circle-outline</v-icon>
                  </v-btn>
                </template>
                <span>{{ item.estado == 3 ? 'Ya verificado' : 'Verificar depósito' }}</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon small color="indigo darken-1"
                    @click="$router.push('/depositostodepos?idcaja='+item.caja_id+'&depoid='+item.id+'&other=1')">
                    <v-icon small>mdi-bank-transfer</v-icon>
                  </v-btn>
                </template>
                <span>Depósitos del depósito</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </div>

    <!-- Dialog detalles -->
    <v-dialog v-model="dialog" max-width="680" scrollable>
      <v-card class="dp-dialog">
        <v-card-title class="dp-dialog__header">
          <v-icon color="white" class="mr-2">mdi-bank-transfer-in</v-icon>
          <span class="white--text text-subtitle-1 font-weight-bold">Detalle del depósito</span>
          <v-spacer />
          <v-btn icon dark small @click="dialog = false"><v-icon small>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="pt-4 pb-2">
          <!-- Info general -->
          <div class="dp-dlg-label mb-2">Información general</div>
          <v-card outlined class="pa-3 mb-3">
            <v-row dense>
              <v-col cols="6" sm="4"><div class="dp-key">Creado por</div><div class="dp-val">{{ dialogitem.created_by || '—' }}</div></v-col>
              <v-col cols="6" sm="4"><div class="dp-key">Caja ID</div><div class="dp-val">{{ dialogitem.caja_id || '—' }}</div></v-col>
              <v-col cols="6" sm="4"><div class="dp-key">Usuario ID</div><div class="dp-val">{{ dialogitem.user_id || '—' }}</div></v-col>
              <v-col cols="6" sm="4"><div class="dp-key">Sede</div><div class="dp-val">{{ dialogitem.sede ? dialogitem.sede.nombre : '—' }}</div></v-col>
              <v-col cols="6" sm="4"><div class="dp-key">Cuenta bancaria ID</div><div class="dp-val">{{ dialogitem.cuenta_bancaria_id || '—' }}</div></v-col>
              <v-col cols="6" sm="4"><div class="dp-key">Verificado por</div><div class="dp-val">{{ dialogitem.verificado_by || '—' }}</div></v-col>
              <v-col cols="6" sm="4">
                <div class="dp-key">Estado</div>
                <v-chip x-small label :color="estadoColor(dialogitem.estado).bg" :class="estadoColor(dialogitem.estado).text">
                  {{ getEstado(dialogitem.estado) }}
                </v-chip>
              </v-col>
            </v-row>
          </v-card>

          <!-- Montos y fechas -->
          <div class="dp-dlg-label mb-2">Montos y fechas</div>
          <v-card outlined class="pa-3 mb-3">
            <v-row dense>
              <v-col cols="6" sm="3"><div class="dp-key">Monto recaudado</div><div class="dp-val teal--text text--darken-1 font-weight-bold">{{ dialogitem.monto_recaudado }} Bs</div></v-col>
              <v-col cols="6" sm="3"><div class="dp-key">Monto depositado</div><div class="dp-val blue--text text--darken-1 font-weight-bold">{{ dialogitem.monto_depositado }} Bs</div></v-col>
              <v-col cols="6" sm="3"><div class="dp-key">Fecha depósito</div><div class="dp-val">{{ dialogitem.fecha_deposito || '—' }}</div></v-col>
              <v-col cols="6" sm="3"><div class="dp-key">Fecha verificación</div><div class="dp-val">{{ dialogitem.fecha_verificacion || '—' }}</div></v-col>
              <v-col cols="6" sm="3"><div class="dp-key">Comprobante</div><div class="dp-val">{{ dialogitem.comprobante || '—' }}</div></v-col>
              <v-col cols="6" sm="3"><div class="dp-key">Creado</div><div class="dp-val">{{ dialogitem.created_at || '—' }}</div></v-col>
            </v-row>
          </v-card>

          <!-- Comprobante -->
          <div class="dp-dlg-label mb-2">Comprobante adjunto</div>
          <v-card outlined class="pa-3">
            <v-alert v-if="!dialogitem.archivo" dense text type="warning" class="mb-0" style="font-size:13px">
              No hay comprobante adjunto para este depósito.
            </v-alert>
            <template v-else>
              <div class="d-flex align-center justify-space-between mb-2">
                <div class="text-caption grey--text">
                  {{ dialogitem.archivo.extencion }} · {{ dialogitem.archivo.mimeType }}
                </div>
                <v-btn small color="teal darken-1" dark :loading="loading" :disabled="loading" @click="saveArchivo()">
                  <v-icon left small>mdi-download</v-icon> Descargar
                </v-btn>
              </div>
              <div class="text-center">
                <object :data="getdatauri(dialogitem.archivo)" type="image/png" style="max-width:100%;border-radius:6px;border:1px solid #e0e0e0;"></object>
              </div>
            </template>
          </v-card>
        </v-card-text>

        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn text color="grey darken-1" @click="dialog = false">
            <v-icon left small>mdi-close</v-icon> Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import xaxios from '@/xaxios';

export default {
    components:{},
    data () {
        return {
            headers: [ 
                { text: '#', value: 'nro' },
                { text: 'Creado por', value: 'created_by' }, 
                { text: 'en fecha', value: 'created_at' },
                { text: 'Monto depositado', value: 'monto_depositado' },
                { text: 'Monto recaudado', value: 'monto_recaudado' }, 
                { text: 'estado', value: 'estado' }, 
                { text: 'sede origen', value: 'sede_caja' }, 
                { text: 'sede destino', value: 'sede' }, 
                { text: '', value: 'opt' },
            ],
            desserts: [],
            eliminados: false,
            loading: false,
            dialog: false,
            dialogitem:{},
        }
    },
    watch:{ 
        '$store.state.CARGO': function(){
            this.cargarDatos();
        }
    },
    methods:{
        async cargarDatos(){
            this.loading = true;
            this.desserts = [];
            let idsede = this.$store.state.CARGO.sede.id;
            let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/depositocajas/${idsede}/sede`; 
            const res = await xaxios.get(url).then(x=>x).catch(x=>x);
            // window.console.log('sededestinos:', res.data);
            if(res && res.data ) {
                res.data.map((x,i)=>{
                    x,
                    x.nro = i+1
                })
                this.desserts = res.data;
            } 
            this.loading = false;
        },
        async obtenerDetalles(depoid){
            this.loading = true;
            let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/depositocajas/${depoid}`; 
            const res = await xaxios.get(url).then(x=>x).catch(x=>x);
            if(res && res.data ){
                // window.console.log('res',res.data);  
                this.dialogitem = {...res.data};
            }
            this.loading = false;
            this.dialog = true;
        }, 
        getdatauri(archivo){
            if(!archivo) return '';
            return `data:${archivo.mimetype};base64,${archivo.file64}`
        },
        estadoColor(est){
            if (est == 1) return { bg: 'orange lighten-5', text: 'orange--text text--darken-2', icon: 'mdi-cash' };
            if (est == 2) return { bg: 'blue lighten-5',   text: 'blue--text text--darken-2',   icon: 'mdi-bank-transfer' };
            if (est == 3) return { bg: 'green lighten-5',  text: 'green--text text--darken-2',  icon: 'mdi-check-circle-outline' };
            return       { bg: 'grey lighten-4',    text: 'grey--text',                  icon: 'mdi-help-circle-outline' };
        },
        getEstado(est){
            if (est == 1) return 'recaudado';
            else if (est == 2) return 'depositado';
            else if (est == 3) return 'verificado';
            else return '??';
        },
        saveArchivo(){
            /* var link = document.createElement("a");
            link.download = "deposito.docx";
            link.href = this.dialogitem.archivo;
            link.click(); */

            const base64String = this.dialogitem.archivo.file64
            const ext = this.dialogitem.archivo.extencion
            window.console.log('base64String',this.dialogitem.archivo);
            
            // Intentar extraer el tipo MIME y la parte Base64 real
            let mimeType = 'application/octet-stream'; // Valor por defecto si no se encuentra
            let base64Data = base64String;
            let suggestedExtension = '';

            const mimeMatch = base64String.match(/^data:(.*?);base64,/);
            if (mimeMatch && mimeMatch[1]) {
                mimeType = mimeMatch[1];
                base64Data = base64String.split(',')[1];

                // Intentar inferir la extensión del archivo del tipo MIME
                const parts = mimeType.split('/');
                if (parts.length > 1) {
                    // Casos especiales para extensiones comunes
                    if (parts[0] === 'image' && parts[1] === 'jpeg') {
                        suggestedExtension = '.jpg';
                    } else if (parts[0] === 'image' && parts[1] === 'svg+xml') {
                        suggestedExtension = '.svg';
                    } else if (parts[0] === 'application' && parts[1] === 'vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                        suggestedExtension = '.xlsx';
                    } else if (parts[0] === 'application' && parts[1] === 'vnd.openxmlformats-officedocument.wordprocessingml.document') {
                        suggestedExtension = '.docx';
                    } else {
                        suggestedExtension = '.' + parts[1]; // Generalmente la segunda parte del MIME es la extensión
                    }
                }
            }

            if(ext == "zip") suggestedExtension = ".docx"
            if(ext == "jpg") suggestedExtension = ".jpg"

            // Decodificar el string Base64 a un ArrayBuffer
            const byteCharacters = atob(base64Data);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);

            // Crear un Blob
            const blob = new Blob([byteArray], { type: mimeType });
            const url = URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            // Usar el nombre de archivo proporcionado o uno generado
            a.download = `deposito__${suggestedExtension || ''}`;
            document.body.appendChild(a);
            a.click();

            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        },

        async verificaropen(item){
            // window.console.log('item',item);
            let message = {
                title: 'Para indicar como verificado, valide esta accion:',
                body: '<br> <b>NOTA:</b> Primero verifique el comprobante(con el boton del ojito) que este correcto y luego confirme la verificacion, es su responsabilidad marcar verificado ',
            };
            let options = {
                html: true,
                okText: 'Verificado',
                cancelText: 'Cancelar',
                reverse: true,
                type: 'hard',
                verification: 'verificado',
                verificationHelp: 'Escriba "[+:verification]" para proceder.',
                loader: true,
            };
            let dialogo = await this.$dialog.confirm(message, options).then(d=>d).catch(e=>e);
            if(dialogo){
                // 
                let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/depositocajas/${item.id}`; 
                const res = await xaxios.patch(url).then(x=>x).catch(x=>x);
                window.console.log(res);
                dialogo.close();
                this.cargarDatos();
            }
            // window.console.log('dialogo',dialogo)
        },
        
    },
    async mounted(){ 
        this.cargarDatos();
        
    }
}
</script>

<style scoped>
.dp-page { min-height: 100vh; background: #f5f7fa; }

/* ── Hero ─────────────────────────────────────────────────────────── */
.dp-hero {
  background: linear-gradient(120deg, #1a237e 0%, #283593 50%, #1565c0 100%);
  padding: 20px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.dp-hero__title { font-size: 1.15rem; font-weight: 700; color: #fff; letter-spacing: 0.02em; }
.dp-hero__sub   { font-size: 0.78rem; color: rgba(255,255,255,0.65); margin-top: 2px; }
.dp-hero__chip  { font-size: 0.72rem; font-weight: 600; letter-spacing: 0.04em; }

/* ── Body ─────────────────────────────────────────────────────────── */
.dp-body { padding: 20px 24px; }

/* ── Toolbar ──────────────────────────────────────────────────────── */
.dp-toolbar-card { border-radius: 10px !important; border-color: #e3e8f0 !important; background: #fff; }

/* ── Tabla ────────────────────────────────────────────────────────── */
.dp-table-card { border-radius: 10px !important; border-color: #e3e8f0 !important; overflow: hidden; }
.dp-table >>> thead tr th {
  background: #e8edf7 !important;
  color: #1a237e !important;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid #c5cae9 !important;
  padding: 8px 14px !important;
}
.dp-table >>> tbody tr:hover { background: #f0f4ff !important; }
.dp-table >>> tbody tr td {
  font-size: 0.85rem;
  border-bottom: 1px solid #f0f0f0 !important;
  padding: 6px 14px !important;
}

/* ── Dialog ───────────────────────────────────────────────────────── */
.dp-dialog { border-radius: 12px; overflow: hidden; }
.dp-dialog__header {
  background: linear-gradient(120deg, #1a237e 0%, #1565c0 100%);
  padding: 14px 20px !important;
  min-height: 52px;
}
.dp-dlg-label {
  font-size: 0.72rem;
  font-weight: 700;
  color: #1a237e;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.dp-key { font-size: 0.68rem; color: #90a4ae; text-transform: uppercase; letter-spacing: 0.04em; margin-bottom: 2px; }
.dp-val { font-size: 0.875rem; color: #263238; font-weight: 500; }
</style>